export default {
      id: "color_medicine-guy-usage",
      viewBox: "0 0 85 101",
      url: __webpack_public_path__ + "sprite.svg#color_medicine-guy",
      toString: function () {
        return this.url;
      }
    }